import './_Footer.scss';

function Footer() {
  return <footer className="footer">Made by Nic © {new Date().getFullYear()}</footer>;
}

export default Footer;
